import COLORS from '@/constants/colors';

export default {
  wrapper: {
    display: 'inline-flex',
    backgroundColor: COLORS.gray_8,
    p: '14px 16px',
    borderRadius: '8px',
    minWidth: '125px',
  },
  dot: {
    backgroundColor: '#C1DFFF',
    width: '5px',
    height: '5px',
    borderRadius: '50px',
    active: {
      backgroundColor: COLORS.mercanto_blue,
    },
  },
  label: {
    fontSize: '10px',
    color: COLORS.mercanto_blue,
  },
};
